module.exports = __webpack_public_path__ + "static/media/cover2.f127321a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cover2.jpg
// module id = 92
// module chunks = 0